import {DeletedDevicesState} from './states/deleted-devices.state';

export const remoteDevicesState = [
    DeletedDevicesState
];
